require('./bootstrap');

import './charts';
import './libs/formConfirmation';
import './libs/alerts';
import './libs/inputMasks';
import './libs/imagePreview';
import PhoneInput from "./components/phoneInput";
import IMask from 'imask';

import editor from "./editor";

// import Calendar from './components/bookingCallendar';

/**
 * Wysyła żądanie GET z tokenem CSRF do podanego URL i obsługuje odpowiedź.
 *
 * @param {string} url - URL, pod który zostanie wysłane żądanie.
 */
function sendAjaxRequest(url) {
    // Pobranie CSRF tokena z meta tagu
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    // Wysyłanie żądania GET z tokenem CSRF
    fetch(url, {
        method: 'PATCH',
        headers: {
            'X-CSRF-TOKEN': csrfToken, // Dodanie tokena do nagłówków
            'Accept': 'application/json' // Akceptowanie JSON jako odpowiedzi
        }
    })
        .then(response => {
            // Sprawdzenie, czy odpowiedź jest prawidłowa (status 200-299)
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json(); // Zakładamy, że odpowiedź jest w formacie JSON
        })
        .then(data => {
            // Sprawdzenie odpowiedzi z serwera
            if (data !== true) {
                alert("Nie udało się wykonać operacji.");
            }
        })
        .catch(error => {
            console.error("Błąd podczas wykonywania żądania:", error);
            alert("Wystąpił błąd podczas komunikacji z serwerem.");
        });
}

// Udostępnienie funkcji globalnie
window.sendAjaxRequest = sendAjaxRequest;

// Funkcja fix dla android webview
// function setVh() {
//     const vh = window.innerHeight * 0.01;
//     document.documentElement.style.setProperty('--vh', `${vh}px`);
//
//     const menu = document.getElementById('main-menu-dropdown');
//     if (menu) {
//         menu.style.height = (window.innerHeight * 0.9) + 'px'; // 90vh w px
//     }
// }
function setVh() {

    // Bezpieczna wysokość widoku
    const docHeight = document.documentElement.clientHeight;
    const vh = docHeight * 0.01;

    // Ustawienie zmiennej CSS --vh
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // Fix wysokości dropdownu
    const menu = document.getElementById('main-menu-dropdown');
    if (menu) {
        const realHeight = docHeight * 0.90; // 90vh stabilne

        menu.style.height = realHeight + 'px';
        menu.style.maxHeight = realHeight + 'px';
    }
}


window.toggleMenu = () => {
    // fix dla android webview
    setVh();
    const elements = [...document.querySelectorAll('#main-menu-dropdown-backdrop, #main-menu-dropdown')];
    elements.forEach(element => element.classList.toggle('open'));

        // --- DETEKCJA WEWNĘTRZNEGO SCROLLOWANIA DLA APLIKACJI WEBVIEW ---
    // Dzięki temu Android (WebView) nie odświeża strony podczas scrollowania menu
    // sprawdź, czy menu zostało otwarte
    const isOpen = document.querySelector('#main-menu-dropdown')?.classList.contains('open');

    console.log('menu open ' + isOpen);

    // poinformuj AndroidInterface
    if (window.AndroidInterface?.setInnerScroll) {
        window.AndroidInterface.setInnerScroll(!!isOpen);
        console.log('AndroidInterface.setInnerScroll(' + isOpen + ')');
    }

}

window.collapseMenu = () => {
    const elements = [...document.querySelectorAll('#main-menu-dropdown-backdrop, #main-menu-dropdown')];
    elements.forEach(element => element.classList.remove('open'));
}

window.openMenu = () => {
    const elements = [...document.querySelectorAll('#main-menu-dropdown-backdrop, #main-menu-dropdown')];
    elements.forEach(element => element.classList.add('open'));
}

window.updateFilenameLabelAfterFileUpload = event => {
    const filename = event.target.value.split("\\").pop();

    const wrapper = event.target.closest('.file-form-group');

    if (!wrapper) return console.warn('There is no proper wrapper around file input element');

    const filenameLabelElement = wrapper.querySelector('label.filename-label');

    if (!filenameLabelElement) return console.warn('There is no proper label for filename');

    filenameLabelElement.innerHTML = filename;
}

if (localStorage.getItem('thin-menu')) collapseMenu();

const initInputMask = () => {
    const elements = [...document.querySelectorAll('input[data-mask]')];
    elements.forEach(element => {
        const mask = element.getAttribute('data-mask');
        IMask(element, {mask, lazy: false});
    });
}

const scrollToElement = element => {
    if (!element) return;
    element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
}

const findInvalidElement = () => {
    const elements = document.querySelectorAll('.is-invalid');
    return [...elements][0] || null;
}

const closeMenuAfterClick = () => {
    const elements = [...document.querySelectorAll('.main-menu__item:not(#open-menu-item)')];
    elements.forEach(element => element.addEventListener('click', () => {
        setTimeout(collapseMenu, 200);
    }));
}

(function () {
    // window.testCalendar = Calendar({selector: '.main-calendar'});
    window.wysiwyg_editor = editor.init('.wysiwyg-editor');

    const menuElements = [...document.querySelectorAll('#open-menu-link, #main-menu-dropdown-backdrop')];
    menuElements.forEach(element => element.addEventListener('click', toggleMenu));

    const phoneInputs = Array.from(document.querySelectorAll('input[type="tel"]'));
    phoneInputs.forEach(input => {
        new PhoneInput(input);
    });

    initInputMask();
    closeMenuAfterClick();

    const invalidElement = findInvalidElement(document.querySelector('form'));
    if (invalidElement)
        scrollToElement(invalidElement);
})();

// --- RAPORTOWANIE STANU MODALI DO ANDROID INTERFACE ---
function reportModalState() {
    const isModalOpen = document.body.classList.contains('modal-open');
    console.log('modal-open ' + isModalOpen);
    if (window.AndroidInterface?.setInnerScroll) {
        window.AndroidInterface.setInnerScroll(isModalOpen);
        console.log('Modal state reported to AndroidInterface:', isModalOpen);
    }
}

// Nasłuchiwanie zdarzeń Bootstrap modal
$(document).on('shown.bs.modal', '.modal', reportModalState);
$(document).on('hidden.bs.modal', '.modal', reportModalState);

document.addEventListener('DOMContentLoaded', () => {
    console.log('Initial state reported to AndroidInterface:', false);
    if (window.AndroidInterface?.setInnerScroll) {
        window.AndroidInterface.setInnerScroll(false);
    }
});
